var map = {
	"./en.json": "aY29",
	"./es.json": "+lAx",
	"./ko.json": "a8i3",
	"./ru.json": "2MCb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "U56v";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n ^\.\/.*\.json$
// module id = U56v
// module chunks = 153